import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  & > div:not(:first-child) {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
`

export const Message = styled.div`
  display: flex;
  flex-direction: column;

  padding: 2rem;

  header {
    color: #303f9f;
    font-weight: 700;

    margin-bottom: 1rem;
  }

  .__content {
    display: flex;
    align-items: center;

    svg {
      color: ${({ color }) => color === 'primary' ? '#303f9f' : '#FF9800'};
      font-size: 3rem;
    }

    > div {
      margin-left: 1rem;
    }

    label {
      display: flex;
      align-items: center;

      cursor: pointer;

      p {
        margin-left: 1rem;
      }
    }
  }
`
